import { render, staticRenderFns } from "./UILink.vue?vue&type=template&id=3d3d4f1c"
import script from "./UILink.vue?vue&type=script&lang=ts"
export * from "./UILink.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d3d4f1c')) {
      api.createRecord('3d3d4f1c', component.options)
    } else {
      api.reload('3d3d4f1c', component.options)
    }
    module.hot.accept("./UILink.vue?vue&type=template&id=3d3d4f1c", function () {
      api.rerender('3d3d4f1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/UILink.vue"
export default component.exports